import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Code adapted from here https://www.restack.io/docs/matomo-knowledge-matomo-react-js-integration
const MatomoPageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    /* eslint-disable no-underscore-dangle */
    window._paq.push(['setCustomUrl', location.pathname]);
    window._paq.push(['trackPageView']);
    /* eslint-enable no-underscore-dangle */
  }, [location]);
  return null;
};

export default MatomoPageViewTracker;
